import { Bot } from 'lucide-react';
import { cn } from '@/lib/utils';

interface VeraAvatarProps {
  size?: 20 | 24 | 28 | 32 | 48 | 64;
  showBadge?: boolean;
  className?: string;
}

const ICON_SIZE: Record<NonNullable<VeraAvatarProps['size']>, number> = {
  20: 12,
  24: 14,
  28: 16,
  32: 18,
  48: 26,
  64: 34,
};

export function VeraAvatar({ size = 32, showBadge = true, className }: VeraAvatarProps) {
  return (
    <div className="relative inline-flex items-center justify-center">
      {/* Caller-supplied className applies to the visible circle so a ring
          or other chrome traces the avatar's silhouette, not the outer
          positioning box (which is square and used for badge anchoring). */}
      <div
        className={cn(
          'flex items-center justify-center rounded-full bg-primary-subtle',
          className
        )}
        style={{ width: size, height: size }}
      >
        <Bot
          className="text-cobalt-strong dark:text-cobalt-strong"
          width={ICON_SIZE[size]}
          height={ICON_SIZE[size]}
          strokeWidth={2}
          aria-label="Vera (AI)"
        />
      </div>
      {showBadge && size >= 28 && (
        <span
          className="absolute -bottom-0.5 -right-1 rounded-md bg-primary-subtle px-1 text-[7px] font-semibold text-cobalt-strong leading-[12px] dark:text-cobalt-strong"
        >
          AI
        </span>
      )}
    </div>
  );
}
